import * as React from 'react';
import { useEffect, useState } from 'react';
import { Button, Typography, Grid, useMediaQuery } from '@mui/material';
import Swal from 'sweetalert2';
import { useSelector, useDispatch } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Pdf } from './Pdf';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { cambiarAlturaBox } from '../funciones/funcionesGlobales';
import { PDF_FILE } from 'constants/icons';
import { guardarDatosMatriculas } from 'app/features/Matriculas/matriculasApi';
import { TIPOS_USUARIO } from 'constants/constants';
import { descargarFile } from 'utils/archivosManager';
import { insertarCancelacion, obtenerCalculoTasaCancelacion } from 'app/features/Profesionales/profesionalesAPI';
import { makeStyles } from '@mui/styles';

//BUSQUEDA PARA EL PDF
import { tipoDocumentoList } from 'app/features/TipoDocumento/tipoDocumentoSlice';
import { estadoCivilList } from 'app/features/EstadoCivil/estadoCilvilSlice';
import { obrasSocialesList } from 'app/features/TiposObrasSociales/tiposObrasSocialesSlice';
import { parentescosList } from 'app/features/Parentescos/parentescosSlice';
import { PagoCancelacion } from './PagoCancelacion';
import { useTheme } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    floatCenter: {
        display: 'flex',
        justifyContent: 'center'
    },
    modal: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '63%',
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
        '@media (max-width: 1500px)': {
            width: '90%',
            padding: '20px',
        },
        '@media (max-width: 600px)': {
            width: '90%',
            padding: '15px',
        },
    },
    modalContent: {
        maxHeight: '70vh',
        overflowY: 'auto',
    },
    closeButton: {
        cursor: 'pointer',
        position: 'absolute',
        top: '10px',
        right: '10px',
    },
    modalStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flex: 1
    },
}));

export const MedioDePago = ({ datos, bloquearBtn, setBloquearBtn, setDatos, setValue, titulosProfesional, setOcultarTabs, loaderBtnGuardar, setLoaderBtnGuardar, idEstado, setIdEstado, ocultarContenido, setOcultarContenido, resultadoPagoTasa, setResultadoPago, estadoOperacion, obtenerResultadoDePago, setEstadoOperacion, setMedioDePago, medioDePago, limpiarNotificaciones, contadorNotificacion, debeGenerarNuevoQR, poseeDeuda, setPoseeDeuda, decidePagar, setDecidePagar, tramiteTienePagoInicial,  tieneDiferenciaEnPago, setTieneDiferenciaEnPago}) => {

    const TipoDocumentos = useSelector(tipoDocumentoList);
    const EstadoCivilList = useSelector(estadoCivilList);
    const ObrasSociales = useSelector(obrasSocialesList);
    const Parentescos = useSelector(parentescosList);
    const titulosRR = useSelector(state => state.titulosRRReducer.titulosRR);

    const [leyendas, setLeyendas] = useState([]);
    const [montarPdf, setMontarPdf] = useState(false);
    const [openConfirmarTerminos, setOpenConfirmacionTerminos] = useState(false);
    const [bloqueBtnConfirmarInscripcion, setBloqueBtnConfirmarInscripcion] = useState(false);
    const [confirmaPago, setConfirmaPago] = useState(true);
    const userType = Number(localStorage.userType);
    const [blobDDJJState, setBlobDDJJState] = useState(null);
    const [enviaSinDeuda, setEnviaSinDeuda] = useState(false);
    const blobRef = React.useRef(null);

    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.down('xs'));

    const guardarDatosCancelacion = (blob) => {
        setLoaderBtnGuardar(true);
        setBloquearBtn(true);
        const size = ((blob.size / 1000) / 1000).toFixed(4);
        const reader = new FileReader();
        const upload = datos.adjuntos;

        if (upload.filter(c => c.fileType === 'Declaración Jurada').length === 0) {
            reader.readAsDataURL(blob)
            reader.onload = () => {
                datos.adjuntos.push({ fileType: 'Declaración Jurada', fileName: 'DDJJ', extension: 'application/pdf', file: reader.result, size: parseFloat(size), url: PDF_FILE, saved: false });
                guardarCancelacion();
            }
        } else {
            reader.readAsDataURL(blob)
            reader.onload = () => {
                upload.filter(c => c.fileType === 'Declaración Jurada')[0].fileName = 'DDJJ';
                upload.filter(c => c.fileType === 'Declaración Jurada')[0].extension = 'application/pdf';
                upload.filter(c => c.fileType === 'Declaración Jurada')[0].size = parseFloat(size);
                upload.filter(c => c.fileType === 'Declaración Jurada')[0].saved = false;
                upload.filter(c => c.fileType === 'Declaración Jurada')[0].file = reader.result;
                guardarCancelacion();
            }
        }
    }

    const guardarCancelacion = () => {
        const data = { ...datos, Observado: false }
        setBloquearBtn(true);
        setLoaderBtnGuardar(true);
        guardarDatosMatriculas({ datos: JSON.stringify(data), estado: idEstado === 1 || idEstado === 2 ? 2 : 6, tpo_tramite: Number(localStorage.tpoTramite) }).then((value) => {
            setIdEstado(2);
            setLoaderBtnGuardar(false);
            setBloquearBtn(false);
            setOpenConfirmacionTerminos(false);
            
            if (value.data.resultado) {
                setValue("5")
                setOcultarContenido(false);
                cambiarAlturaBox('45px');
                setOcultarTabs({ display: '' });
                setBloquearBtn(true);
                Swal.fire({
                    title: '',
                    html: `<div style="text-align: left; font-size: 1.4rem">
                        La fecha de cancelación solo se considerará válida si la solicitud está completa, con datos auténticos y exactos, y los archivos adjuntos resultan legibles y pertinentes. <br/><br/>
                        Si se detectan observaciones, se le notificará por correo electrónico. Una vez corregida y reenviada, la fecha de cancelación corresponderá al día siguiente del reenvío, salvo que la solicitada sea posterior.
                    </div>`,
                    icon: 'success',
                    showCloseButton: true,
                    showCancelButton: false,
                    confirmButtonText: 'Aceptar',
                    cancelButtonText: 'Cancelar',
                    allowOutsideClick: true,
                    width: '75vw'
                })
                if (localStorage.userType != TIPOS_USUARIO.SECRETARIO_TECNICO) {
                    descargarFile(blobDDJJState, 'DDJJ.pdf', false);
                }
            } else {

                Swal.fire({
                    title: 'Atención',
                    html: value.data.mensaje !== '' && value.data.mensaje !== null && value.data.mensaje.indexOf('illegal character among') < 0 ? value.data.mensaje : value.data.mensaje.indexOf('illegal character among') >= 0 ? 'Archivo no encontrado' : 'Ocurrio un error al guardar los datos. Por favor vuelva a intentarlo',
                    icon: 'warning',
                    showCloseButton: true,
                    showCancelButton: false,
                    confirmButtonText:
                        'Aceptar',
                    cancelButtonText:
                        'Cancelar',
                    allowOutsideClick: true
                })
                return false;
            }

        });
    }

    const enviarSolicitud = async () => {
        setBloqueBtnConfirmarInscripcion(true);
        setLoaderBtnGuardar(true);

        const errorDomicilio = datos.domicilios.some(dm => dm.codLocalidad === "-1");

        if (errorDomicilio) {
            setLoaderBtnGuardar(false);
            setBloqueBtnConfirmarInscripcion(false);
            Swal.fire({
                title: 'Atención',
                html: 'Existen domicilios que tienen ingresada la localidad <b> Otros</b>',
                icon: 'warning',
                showCloseButton: true,
                confirmButtonText: 'Aceptar',
                allowOutsideClick: true
            });
            return false;
        }

        try {
            const value = await insertarCancelacion();
            setLoaderBtnGuardar(false);

            if (value.resultado) {
                setIdEstado(7);
                Swal.fire({
                    title: '',
                    html: 'La solicitud se inició correctamente.',
                    icon: 'success',
                    showCloseButton: true,
                    confirmButtonText: 'Aceptar',
                    allowOutsideClick: true
                });
                return true;
            } else {
                setBloqueBtnConfirmarInscripcion(false);
                Swal.fire({
                    title: 'Atención',
                    html: value.data.mensaje && value.data.mensaje.indexOf('illegal character among') < 0
                        ? value.data.mensaje
                        : 'Ocurrió un error al guardar los datos. Por favor vuelva a intentarlo',
                    icon: 'warning',
                    showCloseButton: true,
                    confirmButtonText: 'Aceptar',
                    allowOutsideClick: true
                });
                return false;
            }
        } catch (error) {
            setLoaderBtnGuardar(false);
            setBloqueBtnConfirmarInscripcion(false);
            Swal.fire({
                title: 'Error',
                html: 'Ocurrió un error inesperado.',
                icon: 'error',
                confirmButtonText: 'Aceptar'
            });
            return false;
        }
    };

    const confirmarPagoYGenerarPDF = () => {
        obtenerCalculoTasaCancelacion(localStorage.idLegajo, datos.fechaCancelacion).then((value)=> {
            (value.montoCancelacion === 0) ? setEnviaSinDeuda(true) : setEnviaSinDeuda(false);
            setMontarPdf(true); 
        })
    };

    useEffect(() => {
        if (blobDDJJState) {
            guardarDatosCancelacion(blobDDJJState);
        }
    }, [blobDDJJState]);

    return (
        <Grid>
            {(idEstado === 1 || (idEstado === 6 && datos.Observado === true && localStorage.userType !== "1")) ? (
                <PagoCancelacion datos={datos} setDatos={setDatos} titulosProfesional={[]} bloquearBtn={bloquearBtn} setBloquearBtn={setBloquearBtn} setValue={setValue} setOcultarTabs={setOcultarTabs} loaderBtnGuardar={loaderBtnGuardar} setLoaderBtnGuardar={setLoaderBtnGuardar} idEstado={idEstado} setIdEstado={setIdEstado} ocultarContenido={ocultarContenido} setOcultarContenido={setOcultarContenido} resultadoPagoTasa={resultadoPagoTasa} estadoOperacion={estadoOperacion} obtenerResultadoDePago={obtenerResultadoDePago} setEstadoOperacion={setEstadoOperacion} setResultadoPago={setResultadoPago} setMedioDePago={setMedioDePago} medioDePago={medioDePago} limpiarNotificaciones={limpiarNotificaciones} poseeDeuda={poseeDeuda} setPoseeDeuda={setPoseeDeuda} decidePagar={decidePagar} setDecidePagar={setDecidePagar} contadorNotificacion={contadorNotificacion} debeGenerarNuevoQR={debeGenerarNuevoQR} setMontarPdf={setMontarPdf} enviarSolicitud={enviarSolicitud} confirmarPagoYGenerarPDF={confirmarPagoYGenerarPDF} confirmaPago={confirmaPago} setConfirmaPago={setConfirmaPago} tramiteTienePagoInicial={tramiteTienePagoInicial}  tieneDiferenciaEnPago={tieneDiferenciaEnPago} setTieneDiferenciaEnPago={setTieneDiferenciaEnPago}/>
            ) : (
                !resultadoPagoTasa ? (
                    <Grid container sx={{ height: { xs: '40vh', md: '25vh' } }} alignItems={'center'} justifyContent={'center'}>
                        <Grid item xs={12} md={12} display={'flex'} justifyContent={'center'} alignItems={'center'} mt={3}>
                            <Typography sx={{ fontSize: 18 }}>
                                <b>
                                    Sr./Sra. profesional, su solicitud ha sido enviada satisfactoriamente.
                                </b>
                            </Typography>
                        </Grid>
                        <Grid item md={6} xs={6} >
                            <Button startIcon={<ArrowBackIosIcon />} onClick={() => setValue("5")} variant="contained" color="error" disabled={bloquearBtn}>
                                Atras
                            </Button>
                        </Grid>
                        <Grid item md={6} xs={6}>
                            {localStorage.userType === "1" ?
                                <Grid sx={{ mt: 3 }} container justifyContent="flex-end">
                                    <Button endIcon={<ArrowForwardIosIcon />} variant="contained" disabled={(idEstado === 1 || idEstado === 2 || (idEstado === 6 && datos.Observado === false)) && bloqueBtnConfirmarInscripcion === false ? false : true} onClick={enviarSolicitud} color="secondary">
                                        {loaderBtnGuardar ? (isXs ? (<CircularProgress size={25} />) : (<><CircularProgress size={25} /> Confirmar solicitud </>)) : ('Confirmar solicitud')}
                                    </Button>
                                </Grid>
                                :
                                <Grid sx={{ mt: 3 }} container justifyContent="flex-end">
                                    <Button endIcon={<ArrowForwardIosIcon />} disabled={bloquearBtn} variant="contained" color="secondary">
                                        {loaderBtnGuardar ? (isXs ? (<CircularProgress size={25} />) : (<><CircularProgress size={25} /> Continuar </>)) : ('Continuar')}
                                    </Button>
                                </Grid>
                            }
                        </Grid>
                    </Grid>
                ) : (
                    <PagoCancelacion datos={datos} setDatos={setDatos} titulosProfesional={[]} bloquearBtn={bloquearBtn} setBloquearBtn={setBloquearBtn} setValue={setValue} setOcultarTabs={setOcultarTabs} loaderBtnGuardar={loaderBtnGuardar} setLoaderBtnGuardar={setLoaderBtnGuardar} idEstado={idEstado} setIdEstado={setIdEstado} ocultarContenido={ocultarContenido} setOcultarContenido={setOcultarContenido} resultadoPagoTasa={resultadoPagoTasa} estadoOperacion={estadoOperacion} obtenerResultadoDePago={obtenerResultadoDePago} setEstadoOperacion={setEstadoOperacion} setResultadoPago={setResultadoPago} setMedioDePago={setMedioDePago} medioDePago={medioDePago} limpiarNotificaciones={limpiarNotificaciones} poseeDeuda={poseeDeuda} setPoseeDeuda={setPoseeDeuda} decidePagar={decidePagar} setDecidePagar={setDecidePagar} contadorNotificacion={contadorNotificacion} debeGenerarNuevoQR={debeGenerarNuevoQR} setMontarPdf={setMontarPdf} enviarSolicitud={enviarSolicitud} confirmarPagoYGenerarPDF={confirmarPagoYGenerarPDF} confirmaPago={confirmaPago} setConfirmaPago={setConfirmaPago} tramiteTienePagoInicial={tramiteTienePagoInicial}  tieneDiferenciaEnPago={tieneDiferenciaEnPago} setTieneDiferenciaEnPago={setTieneDiferenciaEnPago}/>
                )
            )}
            {
                (montarPdf && userType !== 1 )&&
                <PDFDownloadLink document={<Pdf datos={datos} ObrasSociales={ObrasSociales} titulosProfesional={titulosProfesional} TipoDocumentos={TipoDocumentos} EstadoCivilList={EstadoCivilList} leyendas={leyendas} Parentescos={Parentescos} titulosRR={titulosRR} poseeDeuda={poseeDeuda} resultadoPagoTasa={resultadoPagoTasa} confirmaPago={confirmaPago} enviaSinDeuda={enviaSinDeuda}/>} fileName="DDJJ.pdf">
                        {({ blob, url, loading, error }) => {
                            if (!loading && blob && !blobRef.current) {
                                blobRef.current = blob;
                                setTimeout(() => setBlobDDJJState(blob), 0);
                            }
                        }
                    }
                </PDFDownloadLink>
            }
        </Grid>

    )
}